<template>
  <v-select
    label="Representante/Vendedor"
    no-data-text="Nenhuma opção disponível"
    :items="vendedores"
    item-value="codigo"
    item-text="nome"
    v-model="vendedorSelecModel"
    :loading="loading"    
  ></v-select>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("base", ["vendedores"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
    vendedorSelecModel: {
      get: function () {
        return this.vendedorSelecionado;
      },
      set: function (value) {
        this.setVendedor(value);
      },
    },
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapMutations("relatorios", ["setVendedor"]),
    ...mapActions("base", ["getVendedores"]),
  },
  async mounted() {
    this.loading = true;
    await this.getVendedores();
    this.setVendedor(this.vendedores[0].codigo);
    this.loading = false;
  },
};
</script>

<style>
</style>